// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReviewItem_review__item__W0iBQ {
	width: 27.8125rem;
	height: 22.25rem;
	flex-shrink: 0;
	border-radius: 0.5rem;
	border: 1px solid var(--ui-accent, #956446);

	padding: 1.88rem;

	display: grid;
	flex-direction: column;
	gap: 1.6rem;
}

.ReviewItem_item__header__Afz9o {
	display: flex;
	gap: 1.6rem;
	align-items: center;
}

.ReviewItem_item__info__ZabXv {
	display: flex;
	flex-direction: column;
	gap: 0.6rem;
}

.ReviewItem_item__name__LRAqp {
	color: var(--accent-color, #956446);

	font-family: 'Noto Sans';
	font-size: 1.375rem;
	font-style: normal;
	font-weight: 500;
	line-height: 160%; /* 2.2rem */
}

.ReviewItem_item__text__UUzMH {
	color: var(--accent-color, #956446);

	/* text small */
	font-family: 'Noto Sans';
	font-size: 1rem;
	font-style: normal;
	font-weight: 400;
	line-height: 160%; /* 1.6rem */
}

.ReviewItem_item__date__8olTE {
	align-self: flex-end;
	color: var(--ui-accent, #956446);

	text-align: left;
	/* text small semibold */
	font-family: 'Noto Sans';
	font-size: 1rem;
	font-style: normal;
	font-weight: 600;
	line-height: 160%; /* 1.6rem */
}

.ReviewItem_item__score__DNLar {
	display: flex;
}

@media (max-width: 1680px) {
	.ReviewItem_review__item__W0iBQ {
		width: 38rem;
	}
}

@media (max-width: 1630px) {
	.ReviewItem_review__item__W0iBQ {
		width: 36rem;
	}
}

@media (max-width: 1560px) {
	.ReviewItem_review__item__W0iBQ {
		width: 34rem;
	}
}

@media (max-width: 1500px) {
	.ReviewItem_review__item__W0iBQ {
		width: 30rem;
	}
}

@media (max-width: 1440px) {
	.ReviewItem_review__item__W0iBQ {
		width: 27.8125rem;
	}
}

@media (max-width: 460px) {
	.ReviewItem_review__item__W0iBQ {
		width: 23rem;
		height: 30rem;
	}
}

@media (max-width: 430px) {
	.ReviewItem_review__item__W0iBQ {
		width: 19.8rem;
		height: 30rem;
	}
}

@media (max-width: 400px) {
	.ReviewItem_review__item__W0iBQ {
		width: 20rem;
		height: 30rem;
	}
}

@media (max-width: 360px) {
	.ReviewItem_review__item__W0iBQ {
		width: 18rem;
		height: 30rem;
	}
}
`, "",{"version":3,"sources":["webpack://./src/Components/DefaultPage/Reviews/ReviewItem/ReviewItem.module.css"],"names":[],"mappings":"AAAA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;CACd,qBAAqB;CACrB,2CAA2C;;CAE3C,gBAAgB;;CAEhB,aAAa;CACb,sBAAsB;CACtB,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,WAAW;AACZ;;AAEA;CACC,mCAAmC;;CAEnC,wBAAwB;CACxB,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;AAC/B;;AAEA;CACC,mCAAmC;;CAEnC,eAAe;CACf,wBAAwB;CACxB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;AAC/B;;AAEA;CACC,oBAAoB;CACpB,gCAAgC;;CAEhC,gBAAgB;CAChB,wBAAwB;CACxB,wBAAwB;CACxB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;AAC/B;;AAEA;CACC,aAAa;AACd;;AAEA;CACC;EACC,YAAY;CACb;AACD;;AAEA;CACC;EACC,YAAY;CACb;AACD;;AAEA;CACC;EACC,YAAY;CACb;AACD;;AAEA;CACC;EACC,YAAY;CACb;AACD;;AAEA;CACC;EACC,iBAAiB;CAClB;AACD;;AAEA;CACC;EACC,YAAY;EACZ,aAAa;CACd;AACD;;AAEA;CACC;EACC,cAAc;EACd,aAAa;CACd;AACD;;AAEA;CACC;EACC,YAAY;EACZ,aAAa;CACd;AACD;;AAEA;CACC;EACC,YAAY;EACZ,aAAa;CACd;AACD","sourcesContent":[".review__item {\n\twidth: 27.8125rem;\n\theight: 22.25rem;\n\tflex-shrink: 0;\n\tborder-radius: 0.5rem;\n\tborder: 1px solid var(--ui-accent, #956446);\n\n\tpadding: 1.88rem;\n\n\tdisplay: grid;\n\tflex-direction: column;\n\tgap: 1.6rem;\n}\n\n.item__header {\n\tdisplay: flex;\n\tgap: 1.6rem;\n\talign-items: center;\n}\n\n.item__info {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 0.6rem;\n}\n\n.item__name {\n\tcolor: var(--accent-color, #956446);\n\n\tfont-family: 'Noto Sans';\n\tfont-size: 1.375rem;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 160%; /* 2.2rem */\n}\n\n.item__text {\n\tcolor: var(--accent-color, #956446);\n\n\t/* text small */\n\tfont-family: 'Noto Sans';\n\tfont-size: 1rem;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 160%; /* 1.6rem */\n}\n\n.item__date {\n\talign-self: flex-end;\n\tcolor: var(--ui-accent, #956446);\n\n\ttext-align: left;\n\t/* text small semibold */\n\tfont-family: 'Noto Sans';\n\tfont-size: 1rem;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 160%; /* 1.6rem */\n}\n\n.item__score {\n\tdisplay: flex;\n}\n\n@media (max-width: 1680px) {\n\t.review__item {\n\t\twidth: 38rem;\n\t}\n}\n\n@media (max-width: 1630px) {\n\t.review__item {\n\t\twidth: 36rem;\n\t}\n}\n\n@media (max-width: 1560px) {\n\t.review__item {\n\t\twidth: 34rem;\n\t}\n}\n\n@media (max-width: 1500px) {\n\t.review__item {\n\t\twidth: 30rem;\n\t}\n}\n\n@media (max-width: 1440px) {\n\t.review__item {\n\t\twidth: 27.8125rem;\n\t}\n}\n\n@media (max-width: 460px) {\n\t.review__item {\n\t\twidth: 23rem;\n\t\theight: 30rem;\n\t}\n}\n\n@media (max-width: 430px) {\n\t.review__item {\n\t\twidth: 19.8rem;\n\t\theight: 30rem;\n\t}\n}\n\n@media (max-width: 400px) {\n\t.review__item {\n\t\twidth: 20rem;\n\t\theight: 30rem;\n\t}\n}\n\n@media (max-width: 360px) {\n\t.review__item {\n\t\twidth: 18rem;\n\t\theight: 30rem;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"review__item": `ReviewItem_review__item__W0iBQ`,
	"item__header": `ReviewItem_item__header__Afz9o`,
	"item__info": `ReviewItem_item__info__ZabXv`,
	"item__name": `ReviewItem_item__name__LRAqp`,
	"item__text": `ReviewItem_item__text__UUzMH`,
	"item__date": `ReviewItem_item__date__8olTE`,
	"item__score": `ReviewItem_item__score__DNLar`
};
export default ___CSS_LOADER_EXPORT___;
